// Error map de Zod en español (Sprint 7 #3).
//
// Zod emite sus mensajes de validación por defecto en INGLÉS (ej. "String must
// contain at least 10 character(s)"). Como esos mensajes se muestran en la UI
// (react-hook-form + zodResolver los pone en los errores de cada campo), todo el
// proyecto debe verlos en español. En vez de traducir campo por campo (se escapa
// alguno), seteamos UN error map global que traduce los códigos de issue de Zod.
//
// Los mensajes EXPLÍCITOS de los schemas (ej. `.refine(fn, 'mi mensaje')` o
// `.min(10, 'mensaje propio')`) NO pasan por este map — Zod usa el mensaje dado.
// Este map sólo cubre los mensajes AUTO-generados.
//
// Se aplica con `setupSpanishZodErrors()` desde el entry del frontend y del
// backend. Opera sobre la instancia de Zod de @app/shared (la que usan los
// schemas), así que afecta a toda validación de schemas compartidos.
import { z } from 'zod';
export const zodErrorMapEs = (issue, ctx) => {
    switch (issue.code) {
        case z.ZodIssueCode.invalid_type:
            if (issue.received === 'undefined' || issue.received === 'null') {
                return { message: 'Requerido' };
            }
            return { message: 'Tipo de dato inválido' };
        case z.ZodIssueCode.too_small: {
            const min = Number(issue.minimum);
            if (issue.type === 'string') {
                return { message: min <= 1 ? 'Requerido' : `Debe tener al menos ${min} caracteres` };
            }
            if (issue.type === 'number') {
                return { message: issue.inclusive ? `Debe ser mayor o igual a ${min}` : `Debe ser mayor a ${min}` };
            }
            if (issue.type === 'array') {
                return { message: min <= 1 ? 'Agregá al menos un elemento' : `Debe tener al menos ${min} elementos` };
            }
            if (issue.type === 'date') {
                return { message: 'La fecha es demasiado temprana' };
            }
            return { message: 'El valor es demasiado chico' };
        }
        case z.ZodIssueCode.too_big: {
            const max = Number(issue.maximum);
            if (issue.type === 'string') {
                return { message: `Debe tener como máximo ${max} caracteres` };
            }
            if (issue.type === 'number') {
                return { message: issue.inclusive ? `Debe ser menor o igual a ${max}` : `Debe ser menor a ${max}` };
            }
            if (issue.type === 'array') {
                return { message: `Debe tener como máximo ${max} elementos` };
            }
            if (issue.type === 'date') {
                return { message: 'La fecha es demasiado tardía' };
            }
            return { message: 'El valor es demasiado grande' };
        }
        case z.ZodIssueCode.invalid_string: {
            if (typeof issue.validation === 'string') {
                if (issue.validation === 'email')
                    return { message: 'Email inválido' };
                if (issue.validation === 'url')
                    return { message: 'URL inválida' };
                if (issue.validation === 'uuid' || issue.validation === 'cuid' || issue.validation === 'cuid2') {
                    return { message: 'Identificador inválido' };
                }
                if (issue.validation === 'datetime')
                    return { message: 'Fecha/hora inválida' };
            }
            return { message: 'Formato inválido' };
        }
        case z.ZodIssueCode.invalid_enum_value:
            return { message: 'Opción inválida' };
        case z.ZodIssueCode.invalid_date:
            return { message: 'Fecha inválida' };
        case z.ZodIssueCode.not_multiple_of:
            return { message: 'El valor no es válido' };
        case z.ZodIssueCode.unrecognized_keys:
            return { message: 'Hay campos no reconocidos' };
        default:
            // Mensajes explícitos de refinements/custom y códigos raros: Zod ya trae
            // el texto (en español si el schema lo definió). No lo pisamos.
            return { message: ctx.defaultError };
    }
};
/** Activa los mensajes de validación de Zod en español (global). */
export function setupSpanishZodErrors() {
    z.setErrorMap(zodErrorMapEs);
}
//# sourceMappingURL=zod-es.js.map